import React from 'react';
import './login.css';
 import { Switcher } from "../../components/switcher"
import { Outlet } from 'react-router-dom';

const FC: React.FC = () => { 
	return (
	<div className="container"> 
       <Switcher/>
    </div>
  );
};
export default FC